import { match } from 'path-to-regexp';

/**
 *
 * @param {string} pattern - The URL pattern with placeholders (e.g., 'orders/:orderId/status')
 * @param {string} path - The actual URL path to extract params from (e.g., 'orders/BFW-123/status')
 * @returns {Object|null} - Extracted parameters object or null if no match
 *
 * @example
 * extractUrlParams('orders/:orderId', 'orders/BFW-123')
 * // Returns: { orderId: 'BFW-123' }
 *
 * extractUrlParams('orders/:orderId/accept', 'orders/BFW-123/accept')
 * // Returns: { orderId: 'BFW-123' }
 */
export const extractUrlParams = (pattern, path) => {
  if (!pattern || !path) {
    return null;
  }

  const matcher = match(pattern, { decode: decodeURIComponent });
  const result = matcher(path);

  if (!result) {
    return null;
  }

  return result.params || {};
};
